import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { changeActiveItem } from '../store/slice'
import classes from './index.module.scss'
import { Label } from './Label'
import { List } from './List'

export const Item = ({
  label,
  children,
  isI18n,
  isChildren,
  isActive,
  activeItem,
  item,
}) => {
  const dispatch = useDispatch()
  const [isShowChild, setIsShowChild] = useState(false)
  const handleClickItem = (item) => {
    if (isChildren) {
      dispatch(
        changeActiveItem({
          id: item.itemId,
          label: item.label,
        }),
      )
      return
    }
    setIsShowChild(!isShowChild)
  }

  useEffect(() => {
    if (item.children?.map((item) => item.itemId).includes(activeItem)) {
      setIsShowChild(true)
    }
  }, [])

  const renderContent = () => {
    return (
      <Element
        className={classes.item}
        style={{
          paddingLeft: isChildren ? 32 : 16,
          backgroundColor: isActive ? '#2C73E8' : '',
          cursor: 'pointer',
          borderColor: '#D5D5D5',
          borderWidth: 1,
          borderStyle: 'solid',
        }}
        onClick={() => handleClickItem(item)}
      >
        <Label
          label={label}
          isActive={isActive}
          isI18n={isI18n}
          isChildren={isChildren}
          style={{ textTransform: 'capitalize' }}
        />
        {children && (
          <Icon
            className={isShowChild ? 'icon-arrow-bottom' : 'icon-arrow-right'}
            style={{ color: '#3A414B', fontSize: 8 }}
          />
        )}
      </Element>
    )
  }

  return (
    <Element
      elementName="li"
      style={{
        backgroundColor: isChildren ? '#F3F3F3' : 'transparent',
      }}
    >
      <Element>{renderContent()}</Element>
      {isShowChild && (
        <>
          {children && (
            <List list={children} isChildren activeItem={activeItem} />
          )}
        </>
      )}
    </Element>
  )
}
